// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"219":"3a6afd9171eda814","335":"6147400f3cf4ba3e","736":"ef05c8f6d62c1a46"}[chunkId] + ".js";
};